class NooviStrengthQuiz extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('.noovi-quiz-step'));
    this.currentStep = 1;

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-quiz-next]')) {
        this.goTo(this.currentStep + 1);
        return;
      }
      if (event.target.closest('[data-quiz-back]')) {
        this.goTo(this.currentStep - 1);
        return;
      }
      if (event.target.closest('[data-quiz-restart]')) {
        this.restart();
        return;
      }
      if (event.target.closest('[data-quiz-close]')) {
        this.close();
        return;
      }
      const line = event.target.closest('.noovi-quiz-line');
      if (line) {
        this.selectLine(line);
      }
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-noovi-quiz]');
      if (trigger) {
        event.preventDefault();
        this.open();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    this.goTo(1);
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  restart() {
    this.querySelectorAll('.noovi-quiz-line').forEach((el) => el.classList.remove('is-selected'));
    this.goTo(1);
  }

  goTo(step) {
    if (step < 1) step = 1;
    if (step > this.steps.length) step = this.steps.length;
    this.steps.forEach((el) => {
      el.hidden = Number(el.dataset.step) !== step;
    });
    this.currentStep = step;
  }

  selectLine(line) {
    this.querySelectorAll('.noovi-quiz-line').forEach((el) => el.classList.remove('is-selected'));
    line.classList.add('is-selected');
    const value = line.dataset.value;
    const resultEl = this.querySelector('[data-quiz-result]');
    if (resultEl) resultEl.textContent = value;
    window.setTimeout(() => this.goTo(this.steps.length), 250);
  }
}

if (!customElements.get('noovi-strength-quiz')) {
  customElements.define('noovi-strength-quiz', NooviStrengthQuiz);
}
